export default {
  coinQuotationUrl: process.env.REACT_APP_COIN_QUOTATION_URL,
  loggerDebug: process.env.REACT_APP_DEBUG_LOGGER,
};
